import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { DialogTermConditionComponent } from './dialog-term-condition.component';

@Injectable({
  providedIn: 'root',
})
export class DialogTermConditionPresenter {
  view!: DialogTermConditionComponent;

  readAndAgreeTerms = true;
  readAndMarketingAgreement = true;
  dialogVisible = false;
  previewDialog = false;

  loading$: Observable<boolean> = of(false);

  private destroy$ = new Subject<void>();

  setView(view: DialogTermConditionComponent): void {
    this.view = view;
  }

  onDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hasAcceptTermAndConditions(): boolean {
    return !!this.view.readAndAgreeTerms && !!this.view.readAndMarketingAgreement;
  }

  toggleDialog(event = true, previewDialog = false): void {
    this.view.dialogVisible = event;
    this.view.previewDialog = previewDialog;
  }

  onSubmit(): void {
    this.toggleDialog(false, true);
  }
}